/**
 * API selection. Mock mode is enabled by VITE_MOCK_API=1, or by running with
 * --mode mock (the default `npm run dev`). Both conditions are statically
 * false in production builds, so the mocks are tree-shaken out of the bundle.
 */

import type { GuestApi, HostApi, SelfServiceApi } from "../types";
import { mockApi } from "./mock";
import { realApi } from "./client";
import { mockHostApi } from "./host.mock";
import { realHostApi } from "./host";
import { mockSelfServiceApi } from "./privacy.mock";
import { realSelfServiceApi } from "./privacy";

const useMock =
  import.meta.env.VITE_MOCK_API === "1" || import.meta.env.MODE === "mock";

export const api: GuestApi = useMock ? mockApi : realApi;
export const hostApi: HostApi = useMock ? mockHostApi : realHostApi;
export const selfServiceApi: SelfServiceApi = useMock
  ? mockSelfServiceApi
  : realSelfServiceApi;
export const isMockMode = useMock;
